import messages from '@shared/js/config/messages.js'
import { languageParam } from '@config/game.js'
import { createI18n } from 'vue-i18n'

const i18n = createI18n({
  legacy: false,
  locale: languageParam || 'en',
  fallbackLocale: 'en',
  messages,
})

export default i18n
